import * as React from 'react';
import PropTypes from 'prop-types';

import Layout from '../components/Layouts/Layout';
import WinnersLayout from '../components/Layouts/WinnersLayout';
import TextBlock from '../components/TextBlock/TextBlock';
import VideoHero from '../components/Video/VideoHero';
import WinnersListing from '../components/Winners/WinnersListing';
import ApplyNow from '../components/WhatIsFreshFund/ApplyNow';

import FreshFundOGImage from '../images/og/freshfund.png';
import '../sass/main.scss';

// Winners Illustrations
import AlexanderMair from '../images/illustrations/Alexander-Mair.png';
import DestinyBrewton from '../images/illustrations/Destiny-Brewton.png';
import JulianBoaitey from '../images/illustrations/Julian-Boaitey.png';
import JustinTrabue from '../images/illustrations/Justin-Trabue.png';
import KamilahHale from '../images/illustrations/Kamilah-Hale-Wordier.png';
import NicoleHawthorne from '../images/illustrations/Nicole-and-Jayla-Hawthorne.png';
import TaneishaJones from '../images/illustrations/Taneisha-Jones.png';
import PaulanaLamonier from '../images/illustrations/Paulana-Lamonier.png';
import TJMorgan from '../images/illustrations/TJ-Morgan.png';
import TyrellJames from '../images/illustrations/Tyrell-James.png';

import Metadata from '../components/Metadata/Metadata';

const ourWinners = [
  {
    name: 'Alexander Mair',
    company: 'ALL IN A BOX',
    image: AlexanderMair,
    slug: '/winners/alexander-mair/',
  },
  {
    name: 'Destiny Brewton',
    company: 'A HOUSE CALLED HUE',
    image: DestinyBrewton,
    slug: '/winners/destiny-brewton/',
  },
  {
    name: 'Julian Boaitey',
    company: 'YENDY',
    image: JulianBoaitey,
    slug: '/winners/julian-boaitey/',
  },
  {
    name: 'Justin Trabue',
    company: 'WARD FOUR WINES',
    image: JustinTrabue,
    slug: '/winners/justin-trabue/',
  },
  {
    name: 'Kamilah Hale',
    company: 'WORDIER',
    image: KamilahHale,
    slug: '/winners/kamilah-hale/',
  },
  {
    name: 'Nicole and Jayla Hawthorne',
    company: "JAYLA'S HEIRLOOMS",
    image: NicoleHawthorne,
    slug: '/winners/nicole-and-jayla-hawthorne/',
  },
  {
    name: 'Taneisha Jones',
    company: 'DREAM CATCHER SOFT PLAY',
    image: TaneishaJones,
    slug: '/winners/taneisha-jones/',
  },
  {
    name: 'Paulana Lamonier',
    company: 'BLACK PEOPLE WILL SWIM',
    image: PaulanaLamonier,
    slug: '/winners/paulana-lamonier/',
  },
  {
    name: 'TJ Morgan',
    company: 'LIFELONG AUDIO',
    image: TJMorgan,
    slug: '/winners/tj-morgan/',
  },
  {
    name: 'Tyrell James',
    company: 'BABBU',
    image: TyrellJames,
    slug: '/winners/tyrell-james/',
  },
];

export default function OurWinners({ location }) {
  return (
    <>
      <Metadata />
      <Layout
        round='2'
        customClass='application-header__left-trap--yellow application-header--small'
      >
        <div className='uk-container uk-margin-large-bottom'>
          <div className='uk-grid' data-uk-grid>
            <div className='uk-width-2-3@m'>
              <TextBlock
                subheading='Fresh Fund'
                heading='This year’s cohort'
                content="<p>Courier Fresh Fund is a $150,000 fund of cash grants for black business owners in the UK and US who have great ideas to start or grow a business. We narrowed down more than 600 applications to 10 winners, who will each receive between $10,000 and $20,000, one-on-one mentorship from a relevant founder and a series of masterclasses. We worked with filmmaker <a class='u-color-black u-medium' href='https://www.joda.studio/' target='_blank' rel='noopener noreferrer'>Naomi Joda</a> to document who the winners are, what drives them and what they hope to achieve in the near future. We're excited for what they've got in store…</p>"
              />
            </div>
          </div>
        </div>
        <WinnersLayout>
          <div className='uk-container'>
            <h3 className='fresh-fund-winners__heading uk-text-center uk-margin-large-bottom'>
              Click on a winner below to check out their film and get to know the story behind their
              business.
            </h3>
            <div className='uk-grid uk-child-width-1-2@s' data-uk-grid>
              <WinnersListing winners={ourWinners} />
            </div>
          </div>
        </WinnersLayout>
        <ApplyNow />
      </Layout>
    </>
  );
}

OurWinners.propTypes = {
  location: PropTypes.object.isRequired,
};
